import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AgendaRepositoryService } from 'src/app/models/agenda/agenda-repository.service';
import { ArticleCodesRepositoryService } from 'src/app/models/article-code/article-codes-repository.service';
import { DeviceTypeRepositoryService } from 'src/app/models/device-type/device-type-repository.service';
import { DeviceRepositoryService } from 'src/app/models/device/device-repository.service';
import { EliotTokenResponse } from 'src/app/models/eliotToken.model';
import { PlantRepositoryService } from 'src/app/models/plant/plant-repository.service';
import { ProductFamilyRepositoryService } from 'src/app/models/product-families/product-family-repository.service';
import { BackofficeRoles } from 'src/app/models/roles.model';
import { ConsentStatusType, EliotUser, UpsUser, UserConsentStatus } from 'src/app/models/user/user.model';
import { UserService } from 'src/app/models/user/user.service';
import { AuthService } from 'src/app/service/authentication/auth.service';
import { environment } from 'src/environments/environment';

const UpsUserStorageKey = 'UPS-UpsUser';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public loginCompleted = false;
  private codeString = 'code';

  constructor(private router: Router,
              public translate: TranslateService,
              private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              private userService: UserService,
              private deviceRepo: DeviceRepositoryService,
              private articleRepo: ArticleCodesRepositoryService,
              private agendaRepo: AgendaRepositoryService,
              private plantRepositoryService: PlantRepositoryService,
              private deviceTypesRepoService: DeviceTypeRepositoryService,
              private familiesRepoService: ProductFamilyRepositoryService) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params: any) => {
      if (params[this.codeString]) {
        this.authService.getAuthToken(params[this.codeString])
        .subscribe((res: EliotTokenResponse) => {
          if (res) {
            this.authService.accessToken = res.access_token;
            this.authService.idToken = res.id_token;
            this.authService.refreshToken = res.refresh_token;
            this.authService.tokenExpiresIn = res.expires_in;
            this.authService.setTimeoutRefreshToken();

            this.userService.loadEliotUser()
              .subscribe((user: any) => {
                if (user.profile.language) { this.authService.languageId = user.profile.language; }
                else { this.authService.languageId = user.profile.country; }

                const dateFormat = localStorage.getItem(environment.storage.settingsDateFormat);
                if (dateFormat === 'null') { this.userService.dateFormat = 'dd/MM/yyyy'; }
                this.saveUser(user);

                this.userService.getUserConsentStatus()
                  .subscribe((result: any[]) => {
                    let toUpdateConsent = false;
                    this.userService.touDocs = result;
                    if (!this.userService.touDocs) { this.loadUpsUser(false); }
                    if (this.userService.touDocs.length === 0) {
                      this.loadUpsUser(false);
                    } else {
                      this.userService.touDocs.forEach((doc: UserConsentStatus) => {
                        if (doc.action.type === ConsentStatusType.CONSENT || doc.action.type === ConsentStatusType.UPDATE) {
                          toUpdateConsent = true;
                        }
                      });
                      this.loadUpsUser(toUpdateConsent);
                    }
                  });
              }, error => {
                console.log(error);
              });
            this.loginCompleted = true;

          }

        }, (error) => {
          console.log(error);
          this.router.navigateByUrl('/prelogin');
        });
      }
    });
  }

  saveUser(user: any): void {
    if (user) {
      const loggedUser = new EliotUser();
      loggedUser.email = user.profile.email;
      loggedUser.givenName = user.profile.givenName;
      loggedUser.displayName = user.profile.displayName;
      loggedUser.surname = user.profile.surname;
      if (user.profile.language) { loggedUser.language = user.profile.language; }
      else { loggedUser.language = user.profile.country; }
      loggedUser.country = user.profile.country;
      loggedUser.marketingCampaigns = user.account.marketingCampaigns.status;
      loggedUser.profiling = user.account.profiling.status;
      this.userService.eliotUser = loggedUser;
    }
  }

  loadUpsUser(toUpdateConsent: boolean): void {
    this.userService.loadUpsUser()
      .subscribe((user: UpsUser) => {
        this.userService.upsUser = user;
        sessionStorage.setItem(UpsUserStorageKey, JSON.stringify(user));
        this.agendaRepo.getAllAgendaByUser();
        this.agendaRepo.getUserNotificationCount();
        this.userService.getSasToken();
        this.articleRepo.loadArticleCodes();
        this.plantRepositoryService.getPlants();
        if (user.backofficeRole !== null) {
          if (toUpdateConsent) { this.router.navigateByUrl('/policy-terms'); }
          else if (user.backofficeRole === BackofficeRoles.LEGRAND_ADMIN) {
            this.router.navigateByUrl('/backoffice');
          }
          else if (user.backofficeRole === BackofficeRoles.LEGRAND_SERVICE) { this.router.navigateByUrl('/backoffice/home/warranty'); }
        } else {
          this.deviceRepo.getUserDevices();
          if (toUpdateConsent) { this.router.navigateByUrl('/policy-terms'); }
          else { this.router.navigateByUrl('/app'); }
        }
      }, error => {
        console.log('LOAD UPS USER ERROR');
        console.log(error);
        this.router.navigateByUrl('/app');
      });

  }

}
